//NEWS_GET_NEWS

var Dispatcher = require('../dispatcher/appDispatcher'),
  ActionType = require('../constants/actionType'),
  NewsApi = require('../api/newsApi');

var NewsAction = {

  getNews: function () {
    NewsApi.getNews().then(function (newsList) {
      Dispatcher.dispatch({
        actionType: ActionType.NEWS_GET_NEWS,
        news: newsList
      })
    });
  }

};

module.exports = NewsAction;
